import html2pdf from 'html2pdf.js';

/**
 * Trigger browser download for a Blob.
 */
export const downloadBlob = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
};

/**
 * Build a PDF from a tabular dataset using html2pdf.
 * @param {Object} opts - { title, subtitle, columns: string[], rows: string[][], filename, orientation }
 */
export const exportTableToPdf = ({ title, subtitle, columns, rows, filename, orientation = 'portrait' }) => {
  const container = document.createElement('div');
  container.style.padding = '24px';
  container.style.fontFamily = 'Arial, Helvetica, sans-serif';
  container.style.color = '#111';
  container.style.background = '#fff';
  container.style.width = orientation === 'landscape' ? '1100px' : '780px';

  const headerHtml = `
    <div style="border-bottom:2px solid #1E3A5F;padding-bottom:12px;margin-bottom:16px;">
      <h1 style="margin:0;font-size:22px;color:#1E3A5F;">${title}</h1>
      ${subtitle ? `<p style="margin:4px 0 0 0;color:#555;font-size:12px;">${subtitle}</p>` : ''}
      <p style="margin:6px 0 0 0;color:#888;font-size:10px;">Generated: ${new Date().toLocaleString()}</p>
    </div>
  `;

  const colCount = columns.length;
  const headHtml = `<tr>${columns
    .map((c) => `<th style="background:#1E3A5F;color:#fff;text-align:left;padding:8px 10px;font-size:11px;border:1px solid #1E3A5F;">${escapeHtml(c)}</th>`)
    .join('')}</tr>`;

  const bodyHtml = rows
    .map(
      (row, idx) =>
        `<tr style="background:${idx % 2 === 0 ? '#fff' : '#f7f7f9'};">${row
          .map(
            (cell) =>
              `<td style="padding:6px 10px;font-size:10.5px;border:1px solid #e5e7eb;vertical-align:top;">${escapeHtml(
                cell == null ? '' : String(cell)
              )}</td>`
          )
          .join('')}</tr>`
    )
    .join('');

  const tableHtml = `
    <table style="width:100%;border-collapse:collapse;table-layout:fixed;word-wrap:break-word;">
      <thead>${headHtml}</thead>
      <tbody>${bodyHtml || `<tr><td colspan="${colCount}" style="padding:12px;color:#888;text-align:center;border:1px solid #e5e7eb;">No data</td></tr>`}</tbody>
    </table>
  `;

  container.innerHTML = headerHtml + tableHtml;
  document.body.appendChild(container);

  const opt = {
    margin: [10, 10, 10, 10],
    filename: filename || 'export.pdf',
    image: { type: 'jpeg', quality: 0.95 },
    html2canvas: { scale: 2, useCORS: true },
    jsPDF: { unit: 'mm', format: 'a4', orientation },
    pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
  };

  return html2pdf()
    .from(container)
    .set(opt)
    .save()
    .finally(() => {
      document.body.removeChild(container);
    });
};

const escapeHtml = (str) =>
  String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
